import * as React from "react"

//https://react-svgr.com/playground/
function SvgIconDiaMadreOn(props) {
    return (
        <svg
            width={244}
            height={244}
            viewBox="0 0 244 244"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx={121.648} cy={122} r={117} fill="#000" />
            <path
            d="M121.918 243.452C54.686 243.452 0 188.845 0 121.731 0 54.607 54.696 0 121.918 0c67.223 0 121.918 54.607 121.918 121.731 0 67.114-54.695 121.721-121.918 121.721zm0-236.635c-63.463 0-115.11 51.553-115.11 114.924 0 63.361 51.637 114.914 115.11 114.914 63.464 0 115.1-51.553 115.1-114.914 0-63.37-51.636-114.924-115.1-114.924z"
            fill="#000"
            />
            <path
            d="M182.103 36.691c0-10.7 8.707-19.364 19.414-19.364 10.718 0 19.395 8.664 19.395 19.364 0 10.68-8.677 19.364-19.395 19.364-10.707.01-19.414-8.674-19.414-19.364z"
            fill="#000"
            />
            <path
            d="M191.06 36.691c0-5.77 4.669-10.42 10.457-10.42 5.789 0 10.448 4.65 10.448 10.42 0 5.75-4.649 10.42-10.448 10.42-5.788 0-10.457-4.67-10.457-10.42z"
            fill="#FFDD00"
            />
            <path
            d="M165 68.4h-22.531V57.9c0-1.6-1.308-2.9-2.917-2.9a2.91 2.91 0 00-2.917 2.9v10.5h-32.389V57.9c0-1.6-1.308-2.9-2.917-2.9a2.91 2.91 0 00-2.917 2.9v10.5H79.1c-9.456 0-17.1 7.6-17.1 17v85.4c0 9.4 7.644 17 17.1 17H165a16.95 16.95 0 0016.999-17V85.4c.101-9.4-7.544-17-16.999-17zM67.834 170.8v-69.9h108.432v69.9c0 6.2-5.03 11.2-11.266 11.2H79.1c-6.237 0-11.266-5-11.266-11.2zM79.1 74.1h19.413v2.4c-4.024 1.6-5.935 6.1-4.426 10.1 1.61 4 6.136 5.9 10.159 4.4 4.024-1.6 5.935-6.1 4.426-10.1-.805-2-2.414-3.6-4.426-4.4v-2.4h32.389V77c-3.722 2.1-5.13 6.8-3.018 10.6 2.112 3.7 6.84 5.1 10.662 3 3.722-2.1 5.13-6.8 3.018-10.6-1.006-1.8-2.817-3.2-4.828-3.7v-2.2h22.632c6.236 0 11.265 5 11.265 11.2v9.8H67.834v-9.8c0-6.1 5.03-11.2 11.266-11.2zm63.369 9.6c0 .3-.101.6-.201.8.1-.2.1-.5.201-.8z"
            fill="#FFDD00"
            stroke="#FFDD00"
            strokeWidth={1.994}
            strokeMiterlimit={10}
            />
            <path
            d="M142.67 125.2l-10.763-1.6-4.828-9.6c-1.71-3.4-5.934-4.8-9.354-3.1-1.308.7-2.414 1.7-3.119 3.1l-4.828 9.8-10.762 1.6c-3.823.5-6.438 4.1-5.834 7.8.2 1.5.905 2.9 2.011 3.9l7.846 7.5-1.81 10.7c-.302 2 .201 4 1.508 5.6a6.974 6.974 0 008.55 1.7l9.656-5.1 9.657 5.1c1.005.5 2.112.8 3.218.8 2.012 0 4.024-.9 5.331-2.5 1.308-1.5 1.912-3.6 1.509-5.6l-1.81-10.7 7.745-7.5c2.816-2.6 2.917-7 .302-9.8-1.208-1.1-2.616-1.9-4.225-2.1zm-.201 7.6l-9.556 9.3c-.302.3-.402.6-.302 1l2.314 13.1v.6c-.101.1-.101.2-.201.3h-1.006l-12.171-5.8a.918.918 0 00-1.006 0l-11.769 6.2h-.905c-.1-.1-.201-.2-.201-.3a.632.632 0 010-.6l2.213-13.1c.1-.4-.101-.7-.302-1l-9.556-9.3a.55.55 0 01-.301-.5c-.1-.6.301-1.2.905-1.4l1.71-.2 11.567-1.7c.202 0 .302-.1.503-.2s.302-.2.302-.4l5.834-11.9c.201-.4.604-.6 1.006-.6.201 0 .402 0 .503.1.201.1.302.3.402.4l5.834 11.9c.101.2.201.3.302.4.1.1.302.2.503.2l13.177 1.9c.603.1 1.005.6.905 1.2v.1c-.101.1-.302.2-.503.3h-.201z"
            fill="#FFDD00"
            stroke="#FFDD00"
            strokeWidth={1.994}
            strokeMiterlimit={10}
            />
        </svg>
    )
}

export default SvgIconDiaMadreOn;